import { StringSchema } from 'yup';

function atLeastOneNumber(this: StringSchema, message: string) {
  return this.test('atLeastOneNumber', message, (value) => /\d/.test(value));
}

export default atLeastOneNumber;
